// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2j9qZ","footer":"styles_footer__2Allm"};